import React, { useState, useEffect } from "react";
import styled from "styled-components";

const CheckTC = styled.div`
  display: inline-block;

`

const CheckedBox = (props) => {

  //  console.log(props.checkBoxJsonData, props.checkBoxFlag);
  // console.log(props.checkBoxButton)

  const [checked, setChecked] = useState(props.checkBoxFlag == 'true' ? true : false);
  const [submited, setSubmited] = useState(false);
  const [termsChecked,setTermsChecked]=useState(props.termsCheckBoxFlag == 'true' ? true : false)

  const handleProceed = (event, value) => {

    let item = event.target.parentElement;

    let checkbox = item.querySelector("#consent");

    let inputString = props.checkBoxButton + "<split>" + value;
    // console.log( value)

    // if (checkbox && checkbox.checked) {
  console.log(inputString)
    window["autosubmit"](inputString);
    setSubmited(true);

    document.getElementById("check-term").style.pointerEvents = "none";

    // if (value.includes("Yes")) {
    //   event.target.classList.add("disabledButtonProceed");

    // } else {
    //   event.target.classList.add("disabledButtonProceed");

    // }
    // } 
  };

  const handleCheck = (ev) => {
    setChecked(!checked);

    ///console.log(checked)

    // if (ev.target.checked) {
    //   ev.target.parentElement.nextElementSibling.classList.remove(
    //     "disabledButtonProceed"
    //   );

    // } else {
    //   ev.target.parentElement.nextElementSibling.classList.add(
    //     "disabledButtonProceed"
    //   );

    // }
  };


  return (
    <div id="check-term">
      <div>
        <div style={{ display: "inline-block" }}>
          <CheckTC>
            <input checked={checked}
              type="checkbox"
              id="consent"
              onChange={(ev) => handleCheck(ev)}

            />

          </CheckTC>
        </div>

        <div style={{ paddingLeft: "6px", display: "inline-block", marginLeft: "20px", marginTop: "-24px" }}>
          {props.checkBoxJsonData}
        </div>
      </div>
      {props.termsCheckBox == 'true' ? 
      <React.Fragment>
        <br></br>
        <CheckTC>
          <input checked={termsChecked}
            type="checkbox"
            id="consent"
            onChange={(ev) => setTermsChecked(!termsChecked)}

          />
        </CheckTC>
        <div style={{ paddingLeft: "6px", display: "inline-block", marginLeft: "20px", marginTop: "-24px" }}>
        Yes, I agree with the <a href={props.termsLink} target="_blank"> Terms and Conditions </a>
        </div>
        <br></br>
      </React.Fragment> : null}

      <br></br>

      <div
        id="submitId"
// ${!submited ? checked ? 'action-elem fbot_buttonProceed' : 'action-elem fbot_buttonProceed_disabled' : 'action-elem fbot_buttonProceed_disabled'}
        className={`
        ${props.termsCheckBox == 'true' ?
         (!submited ? termsChecked ? 'action-elem fbot_buttonProceed'
          : 'action-elem fbot_buttonProceed_disabled disabled' : 
          'action-elem fbot_buttonProceed_disabled'): (!submited ? checked ? 'action-elem fbot_buttonProceed' : 'action-elem fbot_buttonProceed_disabled' : 'action-elem fbot_buttonProceed_disabled')}`}

        onClick={() => handleProceed(event, checked ? "Y" : "N")}
      >{props.checkBoxButton}</div>

    </div>
  );
};
export default CheckedBox;
